export const SUCCESS_TEXTS = {
  title: 'Suscribiste tu APV',
  whatNowTitle: '¿Qué viene ahora?',
  whatNowText:
    'Le informaremos a tu empleador para que realice el descuento cada mes. Te recomendamos confirmar si la empresa recibió esta información.',
  voucherTitle: 'Este es tu comprobante',
  voucherTextStart: 'También lo enviamos a tu correo ',
  voucherTextEnd:
    '. Si no lo encuentras en tu bandeja principal, revisa tu spam.',
  voucherWithoutEmailText:
    'Aún no registras un correo para recibir tus comprobantes, por favor agrega uno en ',
  voucherWithoutEmailLink: 'Tus datos.',
  noticeTitle: 'Ten en cuenta que:',
  notices: [
    'El descuento se realizará cada mes.',
    'Si tienes un Ahorro Previsional Voluntario en otra AFP y deseas suspenderlo, debes solicitarlo en la respectiva administradora.',
    'La rentabilidad o ganancias obtenidas son variables en el tiempo.',
  ],
  downloadButton: 'Descargar comprobante',
  homeButton: 'Ir al inicio',
};

export const SUCCESS_LABELS = {
  folio: 'N° folio:',
  monthlyAmount: 'Monto de ahorro mensual:',
  subscriptionDate: 'Fecha de suscripción:',
  firstDiscount: 'Primer descuento:',
  savingStart: 'Inicio ahorro APV:',
  fund: 'Fondo:',
  regime: 'Régimen:',
};
